import React from 'react';

const demoVideos = [
  {
    id: 1,
    title: 'Hospital Management System Overview',
    category: 'Operations',
    url: 'https://www.w3schools.com/html/mov_bbb.mp4',
  },
  {
    id: 2,
    title: 'Clinical Audit Tracker Demo',
    category: 'Governance',
    url: 'https://www.w3schools.com/html/movie.mp4',
  },
  {
    id: 3,
    title: 'Digital Health Strategy Walkthrough',
    category: 'Technology',
    url: 'https://www.w3schools.com/html/mov_bbb.mp4',
  },
  {
    id: 4,
    title: 'Patient Records Module',
    category: 'Operations',
    url: 'https://www.w3schools.com/html/movie.mp4',
  },
  {
    id: 5,
    title: 'Billing & Finance Integration',
    category: 'Finance',
    url: 'https://www.w3schools.com/html/mov_bbb.mp4',
  },
  {
    id: 6,
    title: 'Committee Creation Workflow',
    category: 'Consultancy',
    url: 'https://www.w3schools.com/html/movie.mp4',
  },
  {
    id: 7,
    title: 'Training Portal Demo',
    category: 'Education',
    url: 'https://www.w3schools.com/html/mov_bbb.mp4',
  },
  {
    id: 8,
    title: 'Policy Management System',
    category: 'Governance',
    url: 'https://www.w3schools.com/html/movie.mp4',
  },
  {
    id: 9,
    title: 'SOP Customization Tool',
    category: 'Policy',
    url: 'https://www.w3schools.com/html/mov_bbb.mp4',
  },
  {
    id: 10,
    title: 'Analytics & Reporting Dashboard',
    category: 'Analytics',
    url: 'https://www.w3schools.com/html/movie.mp4',
  },
];

export default function VideoDemoGalleryComponent() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-8 bg-gray-100">
      <h1 className="text-3xl font-bold mb-4">System Demo Gallery</h1>
      <p className="mb-6 text-gray-700">
        Explore IPSA’s system demos and training walkthroughs. Each video highlights key features and workflows.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {demoVideos.map((video) => (
          <div key={video.id} className="border rounded shadow p-4">
            <h2 className="text-lg font-semibold mb-1">{video.title}</h2>
            <p className="text-sm text-gray-500 mb-2">{video.category}</p>
            <video controls className="w-full rounded">
              <source src={video.url} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        ))}
      </div>
    </div>
  );
}
